// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"JR-z","categoryName":"KR-z","categoryNameSearchHeader":"LR-z","categoryContent":"MR-z","bottomAligned":"NR-z","image":"OR-z","imageNoBackground":"PR-z"};